import type { ReactNode } from 'react';
import { AuthHero } from '@/components/organisms/AuthHero';

interface AuthTemplateProps {
  children: ReactNode;
}

export const AuthTemplate = ({ children }: AuthTemplateProps) => {
  return (
    <div className="flex w-full h-full overflow-hidden bg-auth-background">
      <AuthHero />
      {children}
    </div>
  );
};
